module.exports = __webpack_public_path__ + "assets/img/23-s.d82f125.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/23-s.jpg
// module id = 7QxK
// module chunks = 0